export default "__VITE_ASSET__B9c8Iy0O__"